import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import AppConfig from '../../appConfig';
import { getAuthToken, getCompanyId } from '../../common/utils';
import moment from 'moment-timezone';

export const getAxios = (url, axiosRequestConfig,env=AppConfig.appMode) => {
    axiosRequestConfig.headers = {
        userId: localStorage.getItem('userId') ? localStorage.getItem('userId') : AppConfig.env('userId'),
        companyId: localStorage.getItem('company') ? getCompanyId() : null,
        env: env,
        connectionId: sessionStorage.getItem('tabId') ? sessionStorage.getItem('tabId') : AppConfig.env('connectionId'),
        authorization: `Bearer ${getAuthToken()}`,
        'Url': url,
        'Step': 'DataCall',
        'IsWebService': '0',
        'elapsedTime': 0
    };
    url = AppConfig.apiUrl + url;
    var respLoader = trackPromise(
        axios({
            method: 'get',
            url: url,
            data: axiosRequestConfig.params,
            headers: axiosRequestConfig.headers,
            callTime: axiosRequestConfig.params.callTime,
        })
            .then((response) => {
                return response?.data;;
            })
            .catch((response) => {
                console.log(response);
            })
    );
    return respLoader;
}

export const postAxios = (url, axiosRequestConfig, isHideCallTime) => {
    axiosRequestConfig.headers = {
        userId: localStorage.getItem('userId') ? localStorage.getItem('userId') : AppConfig.env('userId'),
        companyId: localStorage.getItem('company') ? getCompanyId() : null,
        env: AppConfig.appMode,
        connectionId: sessionStorage.getItem('tabId') ? sessionStorage.getItem('tabId') : AppConfig.env('connectionId'),
        authorization: `Bearer ${getAuthToken()}`,
        'Url': url,
        'Step': 'DataCall',
        'IsWebService': '0',
        'elapsedTime': 0
    };
    url = AppConfig.apiUrl + url;
    if (!axiosRequestConfig.params.callTime && !isHideCallTime) {
        axiosRequestConfig.params = { ...axiosRequestConfig.params, callTime: new Date() }
    }
    var respLoader = trackPromise(
        axios({
            method: 'post',
            url: url,
            data: axiosRequestConfig.params,
            headers: axiosRequestConfig.headers,
            callTime: axiosRequestConfig.params.callTime,
        })
            .then((response) => {
                return response?.data;;
            })
            .catch((response) => {
                console.log(response);
            })
    );
    return respLoader;
}
export const getIntSvcAxios = (url, axiosRequestConfig) => {
    axiosRequestConfig.headers = {
        userId: localStorage.getItem('userId') ? localStorage.getItem('userId') : AppConfig.env('userId'),
        env: AppConfig.appMode,
        companyId: localStorage.getItem('company') ? getCompanyId() : null,
        connectionId: sessionStorage.getItem('tabId') ? sessionStorage.getItem('tabId') : AppConfig.env('connectionId'),
        authorization: `Bearer ${getAuthToken()}`,
        'Url': url,
        'Step': 'DataCall',
        'IsWebService': '0',
        'elapsedTime': 0
    };
    url = AppConfig.intSvcApiUrl + url;
    var respLoader = trackPromise(
        axios({
            method: 'get',
            url: url,
            data: axiosRequestConfig.params,
            headers: axiosRequestConfig.headers,
            callTime: axiosRequestConfig.params.callTime,
        })
            .then((response) => {
                return response?.data;;
            })
            .catch((response) => {
                console.log(response);
            })
    );
    return respLoader;
}
export const postIntSvcAxios = (url, axiosRequestConfig, isHideCallTime) => {
    axiosRequestConfig.headers = {
        userId: localStorage.getItem('userId') ? localStorage.getItem('userId') : AppConfig.env('userId'),
        env: AppConfig.appMode,
        connectionId: sessionStorage.getItem('tabId') ? sessionStorage.getItem('tabId') : AppConfig.env('connectionId'),
        authorization: `Bearer ${getAuthToken()}`,
        'Url': url,
        'Step': 'DataCall',
        'IsWebService': '0',
        'elapsedTime': 0
    };
    url = AppConfig.intSvcApiUrl + url;
    if (!axiosRequestConfig.params.callTime && !isHideCallTime) {
        axiosRequestConfig.params = { ...axiosRequestConfig.params, callTime: new Date() }
    }
    var respLoader = trackPromise(
        axios({
            method: 'post',
            url: url,
            data: axiosRequestConfig.params,
            headers: axiosRequestConfig.headers,
            callTime: axiosRequestConfig.params.callTime,
        })
            .then((response) => {
                return response?.data;;
            })
            .catch((response) => {
                console.log(response);
            })
    );
    return respLoader;
}
export const getRRAxios = (url, axiosRequestConfig, isHideLoader) => {
    axiosRequestConfig.headers = {
        userId: localStorage.getItem('userId') ? localStorage.getItem('userId') : AppConfig.env('userId'),
        companyId: localStorage.getItem('userId') ? getCompanyId() : null,
        env: AppConfig.appMode,
        connectionId: sessionStorage.getItem('tabId') ? sessionStorage.getItem('tabId') : AppConfig.env('connectionId'),
        authorization: `Bearer ${getAuthToken()}`,
        'Url': url,
        'Step': 'DataCall',
        'IsWebService': '0',
        'elapsedTime': 0
    };
    url = AppConfig.RRApiURL + url;
    var respLoader = axios({
        method: 'get',
        url: url,
        data: axiosRequestConfig.params,
        headers: axiosRequestConfig.headers,
        callTime: axiosRequestConfig.params.callTime,
    })
        .then((response) => {
            return response?.data;;
        })
        .catch((response) => {
            console.log(response);
        })
    if (isHideLoader) {
        return respLoader;
    }
    return trackPromise(
        respLoader
    );
}

export const postRRAxios = (url, axiosRequestConfig, isFormData, isHideLoader) => {
    axiosRequestConfig.headers = {
        userId: localStorage.getItem('userId') ? localStorage.getItem('userId') : AppConfig.env('userId'),
        companyId: localStorage.getItem('userId') ? getCompanyId() : null,
        env: AppConfig.appMode,
        connectionId: sessionStorage.getItem('tabId') ? sessionStorage.getItem('tabId') : AppConfig.env('connectionId'),
        authorization: `Bearer ${getAuthToken()}`,
        'Url': url,
        'Step': 'DataCall',
        'IsWebService': '0',
        'elapsedTime': 0
    };
    url = AppConfig.RRApiURL + url;
    if (!isFormData && !axiosRequestConfig.params.callTime) {
        axiosRequestConfig.params = { ...axiosRequestConfig.params, callTime: new Date() }
    }
    
    var respLoader =
        axios({
            method: 'post',
            url: url,
            data: axiosRequestConfig.params,
            headers: axiosRequestConfig.headers,
            callTime: axiosRequestConfig.params.callTime,
        })
            .then((response) => {
                return response?.data;;
            })
            .catch((response) => {
                console.log(response);
            })
        ;
    if (isHideLoader) {
        return respLoader;
    }
    return trackPromise(
        respLoader
    );
}

export const getCookie = (c_name) => {
    if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(c_name + "=");
        if (c_start !== -1) {
            c_start = c_start + c_name.length + 1;
            var c_end = document.cookie.indexOf(";", c_start);
            if (c_end === -1) {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return "";
};


export const logUIActions = (path, component, name, action) => {

    let params = {
        logDateTime: moment().utc(),
        userId: localStorage.getItem('userId') ? localStorage.getItem('userId') : AppConfig.env('userId'),
        siteId: 1,
        loginSessionId: getCookie('ai_session'),
        connectionId: sessionStorage.getItem('tabId') ? sessionStorage.getItem('tabId') : "",
        rawUrl: window.location.href,
        component: component,
        path: path,
        action: action,
        name: name,
        companyId: localStorage.getItem('userId') ? getCompanyId() : null,
    };
    let existingLogs = (localStorage.getItem('uiActionsLog') && JSON.parse(localStorage.getItem('uiActionsLog'))) || [];
    existingLogs.push(params);
    let url = AppConfig.apiUrl + 'api/Logs/SaveUIActionLogs';
    if (existingLogs.length > 2 || (process.env.NODE_ENV === 'development' && existingLogs.length > 1)) {
        postAxios(url, { params: existingLogs },true);
        existingLogs = [];
    }
    localStorage.setItem('uiActionsLog', JSON.stringify(existingLogs));
};


